<template>
	<div class="page-header-container">
		<div class="upper-bar" v-if="backButton">
			<div class="back-button" @click="goBack">
				<i class="fal fa-chevron-left"></i>
				<span>Back</span>
			</div>
		</div>
		<div 
			class="page-header"
			:class="{
				'hr': hr
			}"
			>
			<div class="top-block">
				<div class="left-block">
					<div class="title">
						<span v-html="title" />
						<div class="help only-show-on-mobile" v-if="showHelper">
							<i class="fal fa-question-circle" @click="toggleHelp"></i>
						</div>
					</div>
					<div class="desc" v-html="desc" />
				</div>
				<div 
					class="right-block"
					:class="{
						'reverse': reverseRightBlock
					}"
					>
					<div class="help hide-on-mobile" v-if="showHelper">
						<i class="fal fa-question-circle" @click="toggleHelp"></i>
					</div>
					<div class="button-block" v-if="hasButton">
						<Button
							:label="buttonLabel"
							size="regular"
							color="green"
							:icon="buttonIcon"
							:buttonRoute="buttonRoute"
							v-if="buttonRoute"
							/>
					</div>

					<slot></slot>
				</div>
			</div>

			<div class="help-panel" v-if="showHelper && !helpDismissed">
				<div class="icon">
					<i class="fal fa-info-circle"></i>
				</div>
				<div class="help-message">
					<div class="help-title">
						{{ helpTitle }}
					</div>
					<div class="help-desc">
						{{ helpDesc }}
					</div>
				</div>
				<div class="dismiss">
					<Button
						label="Dismiss"
						size="regular"
						color="white"
						icon="times"
						@click="toggleHelp"
						/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Button from '@/Components/Button'

export default {
	props: {
		title: String,
		desc: String,
		hasButton: Boolean,
		buttonLabel: String,
		buttonRoute: String,
		buttonIcon: {
			type: String,
			default: 'plus'
		},
		showHelper: Boolean,
		helpTitle: String,
		helpDesc: String,
		hr: Boolean, // horizontal rule
		backButton: {
			type: Boolean,
			default: true
		},
		reverseRightBlock: {
			type: Boolean,
			default: false
		},
		backLocation: {
			type: String,
			default: null
		}
	},
	components: {
		Button
	},
	remember: ['helpDismissed'],
	data: () => {
		return {
			helpDismissed: true,
			lsState: null
		}
	},
	mounted(){

		this.getState()

	},
	methods: {
		goBack() {
			if(this.backLocation != null){
				this.$inertia.visit(this.backLocation)
			}else{
      	window.history.back()
			}
    },
		toggleHelp(){
			this.helpDismissed = !this.helpDismissed
			this.setState()
		},
		getState(){
			let getLS = window.localStorage.getItem('helpDismissed')
			if(getLS){
				this.lsState = JSON.parse(getLS)
			}
			if(this.lsState != null && this.lsState.includes(this.$page.url)){ // if this page is in the list of URLs where help was dismissed
				this.helpDismissed = true
			}
		},
		setState(){
			if(this.lsState != null){ // if there is state of which URLs have dismissed the help panel

				if(this.helpDismissed && !this.lsState.includes(this.$page.url)){ // if this page has had the help dismissed
					this.lsState.push(this.$page.url)
					window.localStorage.setItem('helpDismissed', JSON.stringify(this.lsState))
				}

			}else{
				let helpDismissedRoutes = []
				if(this.helpDismissed){
					helpDismissedRoutes.push(this.$page.url)
					window.localStorage.setItem('helpDismissed', JSON.stringify(helpDismissedRoutes))
				}
			}
		}
	}
}
</script>

<style lang="sass" scoped>

.page-header-container
	// position: sticky
	// top: 50px
	// z-index: 8
	// backdrop-filter: blur(10px)
	// background-color: rgba(#E1E5E8, 0.3)

	.only-show-on-mobile
		display: none

	@media (max-width: 768px)
		.only-show-on-mobile
			display: block

		.hide-on-mobile
			display: none

.upper-bar
	width: 100%
	display: flex
	justify-content: flex-start
	align-items: center
	padding: 0 0 20px 0

	.back-button
		display: flex
		justify-content: flex-start
		align-items: center
		gap: 10px
		cursor: pointer
		transition: all 300ms

		&:hover
			opacity: 0.8

		span
			font-size: 16px
			font-weight: 400
			font-family: 'Roboto', sans-serif
			color: #777

		.fal
			font-size: 14px
			color: #252525

.page-header
	width: 100%
	display: flex
	margin-bottom: 40px
	flex-direction: column

	&.hr
		padding-bottom: 30px
		border-bottom: 1px solid rgba(#000,0.1)

	.top-block
		width: 100%
		display: flex
		justify-content: space-between
		gap: 20px

		@media (max-width: 768px)
			gap: 10px
			flex-direction: column

		.left-block
			display: flex
			justify-content: flex-start
			flex-direction: column

			.title
				font-size: 48px
				font-weight: 700
				font-family: 'Roboto Condensed', sans-serif
				color: #252525
				line-height: 1.1
				margin-bottom: 10px
				display: flex
				gap: 10px
				align-items: center
				justify-content: space-between

				.fal
					font-size: 26px

				@media (max-width: 768px)
					font-size: 28px

			.desc
				color: #6a6a6a
				font-size: 16px
				font-weight: 400
				font-family: 'Roboto', sans-serif

		.right-block
			display: flex
			justify-content: flex-end
			align-items: center
			gap: 20px

			&.reverse
				flex-direction: row-reverse

			@media (max-width: 768px)
				justify-content: flex-start
				align-items: flex-start
				flex-direction: column !important

			.help
				margin-top: 6px

				.fal
					font-size: 28px
					color: #252525
					cursor: pointer
					transition: all 300ms

					&:hover
						opacity: 0.8

			.button-block
				white-space: nowrap


	.help-panel
		border-radius: 8px
		background-color: #fff
		background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 65%, rgba(222,241,255,1) 100%)
		min-height: 80px
		padding: 40px
		display: grid
		box-shadow: 0 1px 3px rgba(#000, 0.2)
		grid-template-columns: 80px 1fr 180px
		align-items: center
		margin-top: 30px

		@media (max-width: 768px)
			margin-top: 10px

		.icon
			.fal
				color: #252525
				font-size: 52px

		.help-message
			padding-right: 10vw

			.help-title
				font-size: 24px
				font-weight: 700
				font-family: 'Roboto Condensed', sans-serif
				color: #252525
				margin-bottom: 5px
				line-height: 1.1

			.help-desc
				font-size: 16px
				font-weight: 400
				font-family: 'Roboto', sans-serif
				color: #666

		.dismiss
			display: flex
			justify-content: flex-end
			align-items: center

		@media (max-width: 768px)
			padding: 20px
			grid-template-columns: 1fr 1fr
			grid-template-rows: 42px 1fr
			grid-template-areas: "icon dismiss" "message message" 
			row-gap: 20px

			.icon
				grid-area: icon
				justify-self: start

				.fal
					font-size: 36px

			.help-message
				grid-area: message
				padding-right: 0

				.help-title
					font-size: 20px
					margin-bottom: 15px

				.help-desc
					font-size: 14px

			.dismiss
				grid-area: dismiss
				justify-self: flex-end



</style>